import * as React from 'react';
import styled from 'styled-components';
import { StyledInformationalPage } from '../../common/static.styles';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { DefaultLayout } from '../../layout/default/DefaultLayout';

const StyledExtraMarginParagraph = styled.p`
  margin-top: 2em;
`;

// noinspection JSUnusedGlobalSymbols
export default () => (
  <DefaultLayout locale='de-DE'>
    <HeadTitle title='Impressum' />
    <StyledInformationalPage>
      <div className='content'>
        <article>
          <h1>Impressum</h1>
          <p>Angaben gemäß § 5 TMG</p>
          <p>
            Warner Bros. Entertainment GmbH
            <br />
            Gerhofstr. 1-3
            <br />
            20354 Hamburg
            <br />
            <a href='mailto:whvkundenservice@wbd.com'>whvkundenservice@wbd.com</a>
          </p>
          <p>Geschäftsführer: Matthias Heinze, Steffen Schier</p>
          <p>
            Kontakt:
            <br />
            Telefon: +49 (0)40 22 650 - 0
          </p>
          <p>
            Registereintrag:
            <br />
            Registergericht: Amtsgericht Hamburg
            <br />
            Registernummer: HRB58006
          </p>
          <p>USt-Id. gemäß §27 a Umsatzsteuergesetz: DE 305960137</p>
          <p>
            Jugendschutzbeauftragter: Benjamin Vollrath (
            <a href='mailto:benjamin.vollrath@wbd.com'>benjamin.vollrath@wbd.com</a>)
          </p>
          <StyledExtraMarginParagraph>
            Österreich:
            <br />
            Warner Bros. Pictures Ges.m.b.H.
            <br />
            Zieglergasse 10
            <br />
            A-1072 Wien
            <br />
            Geschäftsführer: Matthias Heinze, Steffen Schier
            <br />
            Firmenbuch: FN 51271 Z, Handelsgericht Wien
          </StyledExtraMarginParagraph>
        </article>
      </div>
    </StyledInformationalPage>
  </DefaultLayout>
);
